
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES 256-bit encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activity remains completely private and anonymous with our strict zero-logging policy.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our extensive network of high-speed servers strategically located across multiple countries and continents.'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Lightning Fast Speed',
      description: 'Enjoy seamless browsing, streaming, and downloading with our optimized servers that deliver exceptional speed without compromising security.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously. Our VPN works seamlessly across smartphones, tablets, laptops, and desktop computers with a single account.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is always available to assist you with any questions or technical issues, ensuring a smooth and reliable VPN experience.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h4 className="text-blue-600 font-semibold text-lg mb-3">
            <a href="#features">Why Choose Our VPN</a>
          </h4>
          <h3 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Premium Features for Complete Protection
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the perfect combination of security, speed, and reliability with our advanced VPN solution designed to keep you safe online.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-blue-200">
              <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h5 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h5>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
